import React from "react";

import {
  AccountSectionHeader,
  SectionContent,
} from "../../components/AccountLayout/styles";

function NotificationPreferences() {
  return (
    <SectionContent>
      <AccountSectionHeader>Notification Preferences</AccountSectionHeader>
    </SectionContent>
  );
}

export default NotificationPreferences;
